module.exports = __webpack_public_path__ + "HCP Class.1e0fe87520f78085c890.png";